import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Menu from "./Menu";
import ManagerMenu from "./ManagerMenu";

const ManagerLayout = () => {
    return (
        <>
            <div className="wrapper">
                <Header />
                <ManagerMenu />
                <Outlet />

                {/* <Footer /> */}
                <div id="sidebar-overlay"></div>
            </div>
        </>
    );
};

export default ManagerLayout;
